import React, { useCallback } from 'react'
import { getIn } from 'formik'
import PropTypes from 'prop-types'

import SingleFileUpload from '../../../../forms/ReusableFormFields/SingleFileUpload'

const FileUploadField = ({
  formik,
  fileUrlField,
  fileNameField,
  uploadButtonClassName,
  uploadBtnLabelClassName,
  filePreviewClassName
}) => {
  const { values, setValues, errors, touched } = formik

  const iconTouched = getIn(touched, fileUrlField)
  const iconError = getIn(errors, fileUrlField)
  const iconMissingError = iconTouched && iconError
  const iconUploadedHandler = useCallback(
    uploadedFile => {
      setValues({
        ...values,
        [fileUrlField]: uploadedFile.url,
        [fileNameField]: uploadedFile.name
      })
    },
    [setValues, values, fileUrlField, fileNameField]
  )

  const iconRemoveHandler = useCallback(() => {
    setValues({
      ...values,
      [fileUrlField]: '',
      [fileNameField]: ''
    })
  }, [setValues, values, fileUrlField, fileNameField])

  return (
    <SingleFileUpload
      uploadButtonClassName={uploadButtonClassName}
      uploadBtnLabelClassName={uploadBtnLabelClassName}
      filePreviewClassName={filePreviewClassName}
      fileURL={values[fileUrlField]}
      fileName={values[fileNameField]}
      onFileUploaded={iconUploadedHandler}
      onFileRemove={iconRemoveHandler}
      error={iconMissingError}
      accept="image/png,image/jpg,image/jpeg"
    />
  )
}

FileUploadField.propTypes = {
  formik: PropTypes.object.isRequired,
  fileUrlField: PropTypes.string.isRequired,
  fileNameField: PropTypes.string,
  uploadButtonClassName: PropTypes.string,
  uploadBtnLabelClassName: PropTypes.string,
  filePreviewClassName: PropTypes.string
}

export default FileUploadField
